import React, { useContext } from 'react';
import useExperiment from './useExperiment';
export var ExperimentContext = /*#__PURE__*/React.createContext(null);
export var useExperimentContext = function useExperimentContext() {
  var val = useContext(ExperimentContext);
  if (!val) {
    throw new Error('useExperimentContext must be used within a ExperimentContext.Provider. Are you using ExperimentControl or ExperimentVariant outside Experiment?');
  }
  return val;
};
var Experiment = function Experiment(_ref) {
  var testName = _ref.testName,
    userAttributes = _ref.userAttributes,
    _ref$component = _ref.component,
    Component = _ref$component === void 0 ? 'div' : _ref$component,
    children = _ref.children;
  var _useExperiment = useExperiment({
      testName: testName,
      userAttributes: userAttributes
    }),
    modelExecutionIds = _useExperiment.modelExecutionIds,
    assignedVariantName = _useExperiment.assignedVariantName,
    loading = _useExperiment.loading;
  if (loading) {
    return null;
  }
  if (!children) return null;
  return /*#__PURE__*/React.createElement(ExperimentContext.Provider, {
    value: {
      Component: Component,
      variant: assignedVariantName || 'control',
      modelExecutionIds: modelExecutionIds
    }
  }, children);
};
export default Experiment;